'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loading = require('./Loading');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Loading).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Loading/index.js
// module id = 1350
// module chunks = 0